// Centrale IndexedDB-instantie. Volgt §5.1 / §6 — gebruikt `idb` voor een
// promise-API. Drie object-stores:
//   - scenarios       persoonlijke scenario's (Phase 6)
//   - yearResults     cache van jaarberekeningen, key = scenarioHash
//   - meta            kleine sleutel/waarde-status (toekomstige uitbreidingen)

import { openDB, type IDBPDatabase } from "idb";
import type { YearAggregateResult } from "../shadow/yearAggregate";
import type { Scenario } from "../types/scenario";

const DB_NAME = "schaduwtool";
const DB_VERSION = 1;

interface DbSchema {
  scenarios: {
    key: string;
    value: Scenario;
  };
  yearResults: {
    key: string;
    value: YearAggregateResult;
  };
  meta: {
    key: string;
    value: unknown;
  };
}

let dbPromise: Promise<IDBPDatabase<unknown>> | null = null;

export function getDb(): Promise<IDBPDatabase<unknown>> {
  if (dbPromise) return dbPromise;
  dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("scenarios")) {
        db.createObjectStore("scenarios", { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains("yearResults")) {
        db.createObjectStore("yearResults", { keyPath: "scenarioHash" });
      }
      if (!db.objectStoreNames.contains("meta")) {
        db.createObjectStore("meta");
      }
    },
  });
  return dbPromise;
}

export type { DbSchema };
